<template>
<div class="">
  <h5 class="center">Agregar productos</h5>
  <br/>
  <b-form v-bind:id="'form-item'" @submit.prevent="addItems()">
    <b-row>
      <b-col>
        <b-form-group label-for="" v-bind:label="'Categoria'" v-bind:description="'Categoria'">
          <b-form-select v-bind:name="'idCategory'" v-model="idCategory" :options="categories"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label-for="" v-bind:label="'Sub Categoria'" v-bind:description="'Sub Categoria'">
          <b-form-select v-bind:name="'idSubCategory'" v-model="idSubCategory" :options="subcategories"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label-for="" v-bind:label="'Producto'" v-bind:description="'Producto'">
          <b-form-select @change="getPrice($event)" v-bind:name="'idProduct'" v-model="idProduct" :options="products"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group v-bind:label="'Precio'" v-bind:description="'Precio'">
          <b-input-group>
            <b-form-input type="number" required v-bind:name="'price'" v-model="price" v-bind:placeholder="'Precio'"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group v-bind:label="'Cantidad'" v-bind:description="'Cantidad'">
          <b-input-group>
            <b-form-input type="number" @change="countPrice($event)" @keyup="countPrice($event)" required v-bind:name="'count'" v-model="count" v-bind:placeholder="'Cantidad'"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group v-bind:label="'Total'" v-bind:description="'Total'">
          <b-input-group>
            <b-form-input type="number" required v-bind:name="'total'" v-model="total" v-bind:placeholder="'Total'"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <div class="form-group form-actions">
          <b-button type="submit" class="center mt-30" variant="success"><i class="fa fa-check" aria-hidden="true"></i></b-button>
        </div>
      </b-col>
    </b-row>
  </b-form>
  <div class="">
    <b-table hover ref="tableitems" :items="measureItems" :fields="fields">
      <template slot="action" slot-scope="row">
        <b-button size="sm" @click.stop="editItem(row.item, row.index, $event.target)" class="mr-1">
          <i class="fa fa-pencil"></i>
        </b-button>
        <b-button size="sm" @click.stop="deleteItem(row.item, row.index, $event.target)" class="mr-1">
          <i class="fa fa-times"></i>
        </b-button>
      </template>
    </b-table>
  </div>
</div>
</template>
<script>
import tableItems from '@/components/modules/papeleria/requests/items.vue'
export default {
  name: 'AddItems',
  components: {
    tableItems
  },
  props: {
    dataParams: {}
  },
  data () {
    return {
      selected: null,
      options: [
        {
          value: null,
          text: 'Seleccione una opcion'
        },
        {
          value: '1',
          text: 'Si'
        },
        {
          value: '0',
          text: 'No'
        }
      ],
      categories: [],
      subcategories: [],
      products: [],
      idCategory: null,
      idSubCategory: null,
      idProduct: null,
      price: null,
      count: null,
      total: null,
      items: [],
      fields: [
        {
          key: 'product',
          label: 'Producto'
        },
        {
          key: 'price',
          label: 'Precio'
        },
        {
          key: 'count',
          label: 'Cantidad'
        },
        {
          key: 'total',
          label: 'Total'
        },
        {
          key: 'action',
          label: 'Accion'
        }
      ],
      itemsReactive: [],
      index: null,
      validateUpdate: null
    }
  },
  mounted () {
    this.categoriesSelect().then((response) => {
      this.subcategoriesSelect().then((response) => {
        this.productsSelect().then((response) => {

        }).catch((error) => {
          console.error(error)
        })
      }).catch((error) => {
        console.error(error)
      })
    }).catch((error) => {
      console.error(error)
    })
  },
  computed: {
    measureItems: {
      get: function () {
        return this.itemsReactive
      },
      set: function (newValue) {
        this.itemsReactive = newValue
      }
    }
  },
  methods: {
    select: function (dispatch, state) {
      return this.$store.dispatch(dispatch).then((response) => {
        let data = this.$store.getters[state].items
        let objInit = {
          value: null,
          text: 'Seleccione una opcion'
        }
        let options = []
        options.push(objInit)
        for (var i = 0; i < data.length; i++) {
          let obj = {
            value: data[i].id,
            text: data[i].name
          }
          options.push(obj)
        }
        return options
      }).catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
    },
    categoriesSelect: function () {
      let dispatch = 'inventoryProductsCategoriesAll'
      let state = 'inventoryProductsCategories'
      return this.select(dispatch, state).then((response) => {
        this.categories = response
      }).catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
    },
    subcategoriesSelect: function () {
      let dispatch = 'inventoryProductsSubCategoriesAll'
      let state = 'inventoryProductsSubCategories'
      return this.select(dispatch, state).then((response) => {
        this.subcategories = response
      }).catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
    },
    productsSelect: function () {
      let dispatch = 'inventoryProductsAll'
      let state = 'inventoryProducts'
      return this.select(dispatch, state).then((response) => {
        this.products = response
      }).catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
    },
    getPrice: function (idProduct) {
      let object = {}
      let form = document.getElementById('form-item')
      form.price.value = ''
      form.count.value = ''
      form.total.value = ''
      object.id = idProduct
      let dispatch = 'inventoryProductsShow'
      let state = 'inventoryProducts'
      let json = JSON.stringify(object)
      return this.$store.dispatch(dispatch, json).then((response) => {
        let data = this.$store.getters[state].formData
        this.price = data.price
      }).catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
    },
    countPrice: function (count) {
      this.total = this.price * count
    },
    addItems: function () {
      this.$refs.tableitems.refresh()
      let object = {}
      let form = document.getElementById('form-item')
      var formData = new FormData(form)
      let product = form.idProduct.options[form.idProduct.options.selectedIndex].text
      object['product'] = product
      for (const [key, value] of formData.entries()) {
        object[key] = value
      }
      if (this.items.length > 0) {
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i]) {
            if (this.items[i].idProduct) {
              if (this.items[i].idProduct === object.idProduct) {
                if (this.validateUpdate >= 0) {
                  this.items[this.validateUpdate] = object
                  this.validateUpdate = null
                  this.paintTableItems()
                } else {
                  alert('Ya has ingresado el producto.')
                }
              } else {
                this.items.push(object)
                let json = JSON.stringify(this.items)
                localStorage.setItem('RequestItems', json)
                this.paintTableItems()
              }
            }
          }
        }
      } else {
        this.items.push(object)
        let json = JSON.stringify(this.items)
        localStorage.setItem('RequestItems', json)
        this.paintTableItems()
      }
    },
    paintTableItems: function () {
      this.$refs.tableitems.refresh()
      this.measureItems = this.items
      let form = document.getElementById('form-item')
      form.price.value = ''
      form.count.value = ''
      form.total.value = ''
      form.idCategory.selectedIndex = ''
      form.idSubCategory.selectedIndex = ''
      form.idProduct.selectedIndex = ''
      this.$refs.tableitems.refresh()
      console.log(this.measureItems)
    },
    editItem: function (item, index, target) {
      this.validateUpdate = index
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i]) {
          if (this.items[i].idProduct) {
            if (this.items[i].idProduct === item.idProduct) {
              let form = document.getElementById('form-item')
              form.idCategory.selectedIndex = this.items[i].idCategory
              form.idSubCategory.selectedIndex = this.items[i].idCategory
              form.idProduct.selectedIndex = this.items[i].idCategory
              form.price.value = this.items[i].price
              form.count.value = this.items[i].count
              form.total.value = this.items[i].total
            }
          }
        }
      }
    },
    deleteItem: function (item, index, target) {
      var retVal = confirm('¿Confirma que deseas remover el producto?')
      if (retVal === true) {
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i]) {
            if (this.items[i].idProduct) {
              if (this.items[i].idProduct === item.idProduct) {
                this.items.splice(0, 1)
                this.paintTableItems()
              }
            }
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/papeleria/requests/form/additems.vue